/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NoShow/view.blocks to change it.
import React from 'react'
import Tysiav2CalendarNoShowIcon from 'DesignSystem/Svgs/Tysiav2CalendarNoShowIcon/index'



/** @type {import('Simple/types.js').View} */
export default function NoShow({
  children,
  viewPath = "/DesignSystem/AppointmentBookingStateTextWithIcon/StateIcon/NoShow",
  fill2
  
}) {
  return (<React.Fragment
>
<Tysiav2CalendarNoShowIcon
  viewPath={`${viewPath}/Tysiav2CalendarNoShowIcon`}
 fill2={fill2}
/>
{children}
</React.Fragment>)
}